const onFailure = (error) => ({
  message: 'Cliente já cadastrado!',
  type: 'warning',
});

export default onFailure;
